import { Job } from './Job'
import { loadRailwayExportJobRelated, toInsure, checkJobFiledExist } from '@/api/railwayExport/reBooking'

export class RailwayExportJob extends Job {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'RailwayExportJob'
  }
  get headwayTail() {
    return this._data.headwayTail
  }

  set headwayTail(headwayTail) {
    this._data.headwayTail = headwayTail || false
  }

  get containerLoadType() {
    return this._data.containerLoadType
  }

  set containerLoadType(containerLoadType) {
    this._data.containerLoadType = containerLoadType || ''
  }

  get transportType() {
    return this._data.transportType
  }

  set transportType(transportType) {
    this._data.transportType = transportType || ''
  }

  get fullHalf() {
    return this._data.fullHalf
  }

  set fullHalf(fullHalf) {
    this._data.fullHalf = fullHalf || ''
  }

  get transportLine() {
    return this._data.transportLine
  }

  set transportLine(transportLine) {
    this._data.transportLine = transportLine || ''
  }

  get departureStation() {
    return this._data.departureStation
  }

  set departureStation(departureStation) {
    this._data.departureStation = departureStation || ''
  }

  get transferStation() {
    return this._data.transferStation
  }

  set transferStation(transferStation) {
    this._data.transferStation = transferStation || ''
  }

  get transitStation() {
    return this._data.transitStation
  }

  set transitStation(transitStation) {
    this._data.transitStation = transitStation || ''
  }

  get destinationStation() {
    return this._data.destinationStation
  }

  set destinationStation(destinationStation) {
    this._data.destinationStation = destinationStation || ''
  }

  get destinationCountry() {
    return this._data.destinationCountry
  }

  set destinationCountry(destinationCountry) {
    this._data.destinationCountry = destinationCountry || ''
  }

  get portAgent() {
    return this._data.portAgent
  }

  set portAgent(portAgent) {
    this._data.portAgent = portAgent || 0
  }

  get forwardingAgent() {
    return this._data.forwardingAgent
  }

  set forwardingAgent(forwardingAgent) {
    this._data.forwardingAgent = forwardingAgent || 0
  }

  get paymentMethod() {
    return this._data.paymentMethod
  }

  set paymentMethod(paymentMethod) {
    this._data.paymentMethod = paymentMethod || ''
  }

  get diffPlacesCollaborate() {
    return this._data.diffPlacesCollaborate
  }

  set diffPlacesCollaborate(diffPlacesCollaborate) {
    this._data.diffPlacesCollaborate = diffPlacesCollaborate || false
  }

  get loadingPlaceCompany() {
    return this._data.loadingPlaceCompany
  }

  set loadingPlaceCompany(loadingPlaceCompany) {
    this._data.loadingPlaceCompany = loadingPlaceCompany || 0
  }

  get signBillPlaceCompany() {
    return this._data.signBillPlaceCompany
  }

  set signBillPlaceCompany(signBillPlaceCompany) {
    this._data.signBillPlaceCompany = signBillPlaceCompany || 0
  }

  get fullShipment() {
    return this._data.fullShipment
  }

  set fullShipment(fullShipment) {
    this._data.fullShipment = fullShipment || false
  }

  get dischargePortCompany() {
    return this._data.dischargePortCompany
  }

  set dischargePortCompany(dischargePortCompany) {
    this._data.dischargePortCompany = dischargePortCompany || 0
  }

  get destinationPortCompany() {
    return this._data.destinationPortCompany
  }

  set destinationPortCompany(destinationPortCompany) {
    this._data.destinationPortCompany = destinationPortCompany || 0
  }

  get transfer() {
    return this._data.transfer
  }

  set transfer(transfer) {
    this._data.transfer = transfer || false
  }

  get operationTips() {
    return this._data.operationTips
  }

  set operationTips(operationTips) {
    this._data.operationTips = operationTips || ''
  }

  get loadingTerm() {
    return this._data.loadingTerm
  }

  set loadingTerm(loadingTerm) {
    this._data.loadingTerm = loadingTerm || ''
  }

  get sailingDay() {
    return this._data.sailingDay
  }

  set sailingDay(sailingDay) {
    this._data.sailingDay = sailingDay || ''
  }

  get customs() {
    return this._data.customs
  }

  set customs(customs) {
    this._data.customs = customs || false
  }

  get comercialInspectation() {
    return this._data.comercialInspectation
  }

  set comercialInspectation(comercialInspectation) {
    this._data.comercialInspectation = comercialInspectation || false
  }

  get heating() {
    return this._data.heating
  }

  set heating(heating) {
    this._data.heating = heating || false
  }

  get subTenantId() {
    return this._data.subTenantId
  }

  set subTenantId(subTenantId) {
    this._data.subTenantId = subTenantId
  }
  /* 关联实体-begin */
  get cargoBulkDetail() {
    return this._data.cargoBulkDetail
  }
  set cargoBulkDetail(cargoBulkDetail) {
    this._data.cargoBulkDetail = cargoBulkDetail
  }
  get railwayHeadwayTails() {
    return this._data.railwayHeadwayTails
  }
  set railwayHeadwayTails(railwayHeadwayTails) {
    this._data.railwayHeadwayTails = railwayHeadwayTails
  }
  get customClaim() {
    return this._data.customClaim
  }
  set customClaim(customClaim) {
    this._data.customClaim = customClaim || -1
  }
  /* 关联实体-end */

  // 投保
  static async toInsure(job, office) {
    return await toInsure({ job, office }).then(res => res.data)
  }
  // 检查字段值是否重复
  static async checkJobFieldExist(branchId, lob, jobFields, jobUuid) {
    if (Object.keys(jobFields).length === 0) {
      return {}
    }
    return await checkJobFiledExist({ branchId, lob, jobFields, jobUuid }).then(res => res.data)
  }
  // 加载铁路Job的关联实体信息
  async loadJobRelated(params) {
    params.jobUuid = params.jobUuid || this._data.uuid
    if (!params.jobUuid) {
      return
    }
    // 是否需要载入
    let needLoad = false
    // 将已经加载过的属性的标识置为false
    for (const key in params) {
      if (key === 'jobUuid') {
        continue
      }
      if (key !== 'job' && params[key] && typeof this._data[key] === 'object') {
        params[key] = false
      }
      if (params[key]) {
        needLoad = true
      }
    }
    if (!needLoad) {
      return
    }
    await loadRailwayExportJobRelated(params).then(res => {
      const items = res.data
      if (items.job) {
        for (const key in items.job) {
          if (typeof this._data[key] === 'object') {
            continue
          }
          this._data[key] = items.job[key]
        }
      }
      for (const key in items) {
        if (key === 'job') {
          continue
        }
        this._data[key] = items[key] || null
      }
    })
  }
}
